module.exports = __webpack_public_path__ + "static/media/logo@2x.2d377b02.png";